import CloseRounded from "@mui/icons-material/CloseRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { useWindowSize } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/svgs/logo.svg";
import { LeafButton } from "../buttons";

export const Header = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const languagePrefix = i18n.language === "en" ? "/en" : "/vi";

  const [showDropdown, setShowDropdown] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const { width } = useWindowSize();
  const [menuOpen, setMenuOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMenuOpen(!menuOpen);
    // console.log(menuOpen);
  };
  const navLinks = [
    {
      name: "header.home",
      path: "/",
    },
    {
      name: "header.about",
      path: "/about-us",
    },
    {
      name: "header.products",
      path: null,
      subNavs: [
        {
          name: "header.subProducts.apibanking",
          path: "/banking",
        },
        {
          name: "header.subProducts.BBPS",
          path: "/bbps",
        },
        {
          name: "header.subProducts.url",
          path: "/upi-qr",
        },
        {
          name: "header.subProducts.enach",
          path: "/enach",
        },
        {
          name: "header.subProducts.soundbox",
          path: "/soundbox",
        },
        {
          name: "header.subProducts.ekyc",
          path: "/ekyc",
        },
        {
          name: "header.subProducts.pos",
          path: "/pos-solution",
        },
        {
          name: "header.subProducts.prepaid",
          path: "/prepaid-card",
        },
      ],
    },
    {
      name: "header.media",
      path: "/media",
    },
    // {
    //   name: "header.blog",
    //   path: "",
    // },
    {
      name: "header.contact",
      path: "/contact",
    },
    {
      name: "download",
      path: "/downloads",
    },
  ];

  return (
    <header
      className={`fixed  left-0 right-0 top-0 z-50 w-full bg-white py-[16px] ${
        scrollPosition > 0 ? "shadow-header" : ""
      }`}
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-2 sm:h-full sm:w-full">
        <Link
          to={i18n.language === "en" ? "/en" : "/vi"}
          className="cursor-pointer"
          title="Trusted Pay"
        >
          <img className="h-[54px] w-[225px]" src={logo} alt="Trusted Pay" />
        </Link>
        <ul className="flex items-center lgmax:hidden">
          {navLinks.map((link, index) => {
            const currentLink = link.path
              ? `${languagePrefix}${link.path}`
              : "#";

            return (
              <li
                key={t(link.name)}
                className={`text-4 group px-3 py-[8px] font-montserrat font-semibold xl:px-[20px] ${currentLink === location.pathname ? "text-[--color-hover]" : "text-[--color-title]"}  hover:text-[--color-hover]`}
              >
                <div className="relative flex items-center">
                  <Link
                    to={link.path ? languagePrefix + link.path : "#"}
                    className="whitespace-nowrap"
                  >
                    {t(link.name)}
                    {index === 2 && (
                      <KeyboardArrowDownRoundedIcon className="rotate-0 transition-[all] duration-[2000ms] group-hover/nav:rotate-180" />
                    )}
                    {link.subNavs && (
                      <ul className="absolute left-1/2 top-full hidden -translate-x-1/2 rounded-[5px] bg-white shadow-products after:absolute after:top-[-10px] after:h-[30px] after:w-[150px] after:bg-transparent after:content-[''] group-hover:block">
                        {link.subNavs.map((subLink, index) => {
                          const url = languagePrefix + subLink.path;
                          return (
                            <li
                              className={`text-nowrap ${
                                index === 0
                                  ? "hover:rounded-tl-[5px] hover:rounded-tr-[5px]"
                                  : index === 7
                                    ? "hover:rounded-bl-[5px] hover:rounded-br-[5px]"
                                    : " "
                              } text-[--color-title] hover:bg-[--color-hover] hover:text-white ${url === location.pathname ? "bg-[--color-hover] text-white" : ""}`}
                              key={t(subLink.name)}
                            >
                              <Link
                                to={url}
                                className="ml-[10px] block py-[13px] pl-[14px] pr-[20px]  text-[13px]"
                              >
                                {t(subLink.name)}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </Link>
                </div>
              </li>
            );
          })}
          <li className="ms-2 flex items-center gap-4">
            <a
              href={"/portal"}
              className="whitespace-nowrap px-5 py-4 text-lg font-semibold text-[--tree-leaf]"
            >
              {t("login")}
            </a>
            <a href={"/portal"} className="whitespace-nowrap">
              <LeafButton title={t("signUp")} style={{ height: 58 }} />
            </a>
          </li>
        </ul>
        <IconButton
          aria-label="Open Menu"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            padding: "15px",
            display: width > 1023 ? "none" : "block",
          }}
        >
          {menuOpen ? (
            <CloseRounded sx={{ fontSize: "45px", color: "#2B1C50" }} />
          ) : (
            <MenuIcon sx={{ fontSize: "45px", color: "#2B1C50" }} />
          )}
        </IconButton>
      </div>
      <ul
        className={`  ${
          menuOpen && width < 1023 ? "block" : "hidden"
        } absolute top-[80px] w-full rounded-[10px]  bg-white shadow-header`}
      >
        {navLinks.map((link, index) => {
          const url = link.path ? `${languagePrefix}${link.path}` : "#";
          return (
            <li key={t(link.name)} className="w-full">
              <Link
                className={`block px-[20px] py-[10px] text-[${
                  location.pathname === url ? "#fff" : "--color-title"
                }] ${
                  location.pathname === url ? "bg-[#565ADD]" : "bg-white"
                } text-4 group relative font-montserrat font-semibold hover:bg-[#565ADD] hover:text-white `}
                to={url}
                onClick={() => {
                  if (index === 2) {
                    setShowDropdown(!showDropdown);
                    setMenuOpen(true);
                  } else {
                    setShowDropdown(false); // Close the dropdown when another item is clicked
                    setMenuOpen(false);
                  }
                }}
              >
                {t(link.name)}
                {index === 2 && (
                  <KeyboardArrowDownRoundedIcon
                    className={`group-hover/nav:rotate-180 rotate-${
                      showDropdown ? "180" : "0"
                    } transition-[all] duration-[2000ms]`}
                  />
                )}
              </Link>
              {link.subNavs && showDropdown && (
                <ul className=" bg-white">
                  {link.subNavs.map((subLink) => (
                    <li className="" key={t(subLink.name)}>
                      <Link
                        className={`relative block px-[40px] py-[10px] hover:bg-[#565ADD] hover:text-white text-[${
                          location.pathname ===
                          `${languagePrefix}${subLink.path}`
                            ? "#fff"
                            : "--color-title"
                        }]  ${
                          location.pathname ===
                          `${languagePrefix}${subLink.path}`
                            ? "bg-[#565ADD]"
                            : "bg-white"
                        }`}
                        to={`${languagePrefix}${subLink.path}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        {t(subLink.name)}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
        <li className="space-x-4 py-2.5">
          <a
            href={"/portal"}
            className="px-5 py-4 text-lg font-semibold text-[--tree-leaf]"
          >
            {t("login")}
          </a>
          <a href={"/portal"}>
            <LeafButton title={t("signUp")} style={{ height: 58 }} />
          </a>
        </li>
      </ul>
    </header>
  );
};
